var map = {
	"./ar.json": 846,
	"./ca-ES.json": 847,
	"./de-DE.json": 848,
	"./de.json": 849,
	"./el-GR.json": 850,
	"./el.json": 851,
	"./en-IE.json": 852,
	"./en-US.json": 853,
	"./en.json": 147,
	"./es.json": 854,
	"./fr-FR.json": 855,
	"./fr.json": 856,
	"./hu.json": 857,
	"./it-IT.json": 858,
	"./it.json": 859,
	"./locales.json": 292,
	"./nl.json": 860,
	"./pl.json": 861,
	"./pt-BR.json": 862,
	"./pt.json": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 845;